// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FollowBannerCta-module__followBannerWrap___1r4fB{\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    margin: auto;\n    z-index: 1000;\n    transition: 0.3s ease;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.FollowBannerCta-module__followBannerWrap___1r4fB.FollowBannerCta-module__show___eaFlX {\n    transition: 0.3s ease;\n    opacity: 1;\n    pointer-events: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"followBannerWrap": "FollowBannerCta-module__followBannerWrap___1r4fB",
	"show": "FollowBannerCta-module__show___eaFlX"
};
export default ___CSS_LOADER_EXPORT___;
